import * as appleWatchHelper from './appleWatchHelper';

export default appleWatchHelper;